/* batida-share-layout.js — v6 (2026-05-31): SHARE under the image gallery on
   desktop AND mobile, as a small right-aligned button. Caroline 2026-05-31
   (v2 compact/right; v3 collapse height; v4 center vs OPIS line; v5 mobile
   under picture; v6 nudge mobile SHARE left by the page gutter var(--outer)
   so it lines up with the title/content instead of hugging the screen edge).

   The block always lives in `.grid__item.product__media__wrapper`. Placement
   follows batida-desc-layout.js automatically:
     - Desktop: desc-layout moves the description INTO the media wrapper, so
       SHARE is inserted right before it (centered between photos and OPIS).
     - Mobile: description stays in the info column, so the media wrapper holds
       only the gallery and SHARE is appended after it (under the picture).
   No breakpoint branching in JS; it keys off whether the description is a
   child of the media wrapper. Idempotent guards. Injects a small scoped
   stylesheet; touches no markup, no other block, no template. */

(function () {
  if (window.__batidaShareLayoutLoaded) return;
  window.__batidaShareLayoutLoaded = true;

  function injectStyle() {
    if (document.getElementById('batida-share-layout-css')) return;
    try {
      var css = [
        '.product__block__share{display:flex !important;justify-content:flex-end !important;align-items:center !important;align-self:flex-start !important;height:auto !important;min-height:0 !important;line-height:1 !important;padding:0 !important;margin:14px 0 0 0 !important;}',
        '.product__block__share > *{width:auto !important;max-width:none !important;flex:0 0 auto !important;}',
        '.product__block__share share-button,.product__block__share .share-holder{display:inline-flex !important;width:auto !important;margin:0 !important;}',
        '.product__block__share .share__button{font-size:12px !important;letter-spacing:.04em !important;}',
        '.product__block__share .share__button svg,.product__block__share .icon-core-share-ios{width:13px !important;height:13px !important;}',
        '.product__block__share + .product__block__description{margin-top:14px !important;}',
        '@media (max-width:1023px){.product__block__share{padding-right:var(--outer,16px) !important;}}'
      ].join('');
      var el = document.createElement('style');
      el.id = 'batida-share-layout-css';
      el.textContent = css;
      (document.head || document.documentElement).appendChild(el);
    } catch (e) {}
  }

  function relocate() {
    try {
      var share = document.querySelector('.product__block__share');
      var media = document.querySelector('.grid__item.product__media__wrapper');
      if (!share || !media) return;

      var desc = media.querySelector(':scope > .product__block__description');

      if (desc) {
        if (!(share.parentElement === media && share.nextElementSibling === desc)) {
          media.insertBefore(share, desc);
        }
      } else {
        if (!(share.parentElement === media && share === media.lastElementChild)) {
          media.appendChild(share);
        }
      }
      share.classList.add('batida-share-relocated');
    } catch (e) {
      try { console.warn('batida share-layout relocate error:', e); } catch (_) {}
    }
  }

  function init() {
    if (window.__batidaShareLayoutInit) return;
    window.__batidaShareLayoutInit = true;
    injectStyle();
    relocate();
    setTimeout(relocate, 200);
    setTimeout(relocate, 800);
    setTimeout(relocate, 2000);
    setTimeout(relocate, 5000);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(relocate, 150);
    });

    try {
      var __mo = null, __idle = null;
      var __stop = function () { if (__mo) { try { __mo.disconnect(); } catch (e) {} __mo = null; } };
      var __bump = function () { clearTimeout(__idle); __idle = setTimeout(__stop, 4000); };
      var __arm = function () { if (__mo) return; try { __mo = new MutationObserver(function () { relocate(); __bump(); }); __mo.observe(document.body, { childList: true, subtree: true }); __bump(); } catch (e) {} };
      __arm();
      ['click', 'change'].forEach(function (ev) { document.addEventListener(ev, function () { relocate(); __arm(); }, true); });
    } catch (e) {}
  }

  injectStyle();
  try { relocate(); } catch (_) {}
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else if (document.readyState !== 'complete') {
    window.addEventListener('load', init);
    init();
  } else {
    init();
  }
})();
